import { useEffect } from "react";
import { createConsumer } from "@rails/actioncable";

import toastify from "@vendors/toastify/toastify";

const handleReceivedNotification = (response) => {
  const { type, value, toastId } = response;

  if (!value) return;

  if (toastId) {
    toastify.update({
      type: type || "info",
      value: value,
      toastId: toastId,
    });
  } else {
    toastify.notify({
      type: type || "info",
      value: value,
    });
  }
};

const getWebsocketUrl = () => {
  return process.env.NODE_ENV === "production"
    ? `wss://${window.appContext.kinndomKey}.kinn.app/cable`
    : "ws://localhost:3000/cable";
};

export default function useBroadcastableNotifications() {
  useEffect(() => {
    if (!window.appContext.isAuthenticated) return;

    const websocketUrl = getWebsocketUrl();
    const consumer = createConsumer(websocketUrl);

    const subscriptions = [];

    if (window.appContext.currentUserId) {
      const userNotificationsSubscription = consumer.subscriptions.create({
        channel: "UserNotificationsChannel",
        user_id: window.appContext.currentUserId,
      }, {
        received: handleReceivedNotification,
      });

      subscriptions.push(userNotificationsSubscription);
    }

    if (window.appContext.kinndomKey) {
      const kinndomNotificationsSubscription = consumer.subscriptions.create({
        channel: "KinndomNotificationsChannel",
        kinndom_key: window.appContext.kinndomKey,
      }, {
        received: handleReceivedNotification,
      });

      subscriptions.push(kinndomNotificationsSubscription);
    }

    return () => {
      subscriptions.forEach((subscription) => {
        consumer.subscriptions.remove(subscription);
      });
    };
  }, []);
};
